/* Skeleton.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./Skeleton.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Skeleton as AvatarSkeleton } from '@atlaskit/avatar';
import { Box } from '@atlaskit/primitives/compiled';
import { AvatarItemContainer, ReportingLinesChartCard, ReportsList, VerticalChartLine } from './styles';
var styles = {
  wrapper: "_4t3i12am _1e0c1txw _4cvr1h6o _19bv1b66"
};
export function ReportingLinesSkeleton() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserCardSkeleton, null), /*#__PURE__*/React.createElement(VerticalChartLine, null), /*#__PURE__*/React.createElement(UserCardSkeleton, null), /*#__PURE__*/React.createElement(VerticalChartLine, null), /*#__PURE__*/React.createElement(UserCardSkeleton, null), /*#__PURE__*/React.createElement(VerticalChartLine, null), /*#__PURE__*/React.createElement(ReportsList, null, Array.from({
    length: 8
  }, function (_, i) {
    return /*#__PURE__*/React.createElement(UserCardSkeleton, {
      key: i
    });
  })));
}
export function UserCardSkeleton() {
  return /*#__PURE__*/React.createElement(ReportingLinesChartCard, {
    selected: false
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.wrapper
  }, /*#__PURE__*/React.createElement(AvatarItemContainer, null, /*#__PURE__*/React.createElement(AvatarSkeleton, null))));
}